/* Dunknation cart drawer extras. Dawn's own scripts still run the cart and the drawer.
   This file only adds the product suggestions inside the drawer and makes the free delivery bar move smoothly. */
(function () {
  if (window.__dnCartDrawer) return;
  window.__dnCartDrawer = true;

  var cache = {};
  var lastFill = null;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    /* ---- Suggestions: asked for once the drawer is open, kept for the rest of the page view ---- */
    function load(url) {
      if (!cache[url]) {
        cache[url] = fetch(url, { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (text) {
            if (!text) return '';
            var source = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-dn-recs-src]');
            return source ? source.innerHTML : '';
          })
          .catch(function () { return ''; });
      }
      return cache[url];
    }

    function updateNav(box) {
      var track = box.querySelector('[data-rec-track]');
      var prev = box.querySelector('[data-rec-prev]');
      var next = box.querySelector('[data-rec-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      var x = Math.abs(track.scrollLeft);
      prev.disabled = x < 4;
      next.disabled = x > max - 4;
      var nav = prev.parentElement;
      if (nav) nav.hidden = max < 4;
    }

    function fill() {
      if (!drawer.classList.contains('active') || !window.fetch || !window.DOMParser) return;
      var box = drawer.querySelector('[data-dn-recs]:not([data-done])');
      if (!box) return;
      box.setAttribute('data-done', '');
      load(box.getAttribute('data-url')).then(function (html) {
        if (!html || !box.isConnected) return;
        box.innerHTML = html;
        var inCart = box.getAttribute('data-in-cart') || '';
        each(box.querySelectorAll('[data-rec]'), function (rec) {
          if (inCart.indexOf('|' + rec.getAttribute('data-product-id') + '|') > -1) rec.remove();
        });
        if (!box.querySelector('[data-rec]')) return;
        box.hidden = false;
        var track = box.querySelector('[data-rec-track]');
        if (track) track.addEventListener('scroll', function () { updateNav(box); }, { passive: true });
        updateNav(box);
      });
    }

    /* ---- Free delivery bar: move from the old value to the new one when the cart changes ---- */
    function bar() {
      var el = drawer.querySelector('[data-dn-fill]:not([data-seen])');
      if (!el) return;
      el.setAttribute('data-seen', '');
      var to = el.style.getPropertyValue('--dn-fill');
      if (lastFill && lastFill !== to) {
        el.style.setProperty('--dn-fill', lastFill);
        el.getBoundingClientRect();
        el.style.setProperty('--dn-fill', to);
      }
      lastFill = to;
    }

    function closeSizes(except) {
      each(drawer.querySelectorAll('[data-rec-open][aria-expanded="true"]'), function (button) {
        if (button === except) return;
        button.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }

    drawer.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var arrow = target.closest('[data-rec-prev], [data-rec-next]');
      if (arrow) {
        var box = arrow.closest('[data-dn-recs]');
        var track = box && box.querySelector('[data-rec-track]');
        var card = track && track.querySelector('[data-rec]');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var dir = arrow.hasAttribute('data-rec-next') ? 1 : -1;
        var rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollBy({ left: dir * rtl * (card.offsetWidth + gap), behavior: 'smooth' });
        return;
      }

      var opener = target.closest('[data-rec-open]');
      if (opener) {
        var panel = document.getElementById(opener.getAttribute('aria-controls'));
        if (!panel) return;
        var show = panel.hidden;
        closeSizes(opener);
        panel.hidden = !show;
        opener.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) {
          var first = panel.querySelector('[data-rec-size]:not([disabled])');
          if (first) first.focus({ preventScroll: true });
        }
        return;
      }

      var size = target.closest('[data-rec-size]');
      if (size) {
        var rec = size.closest('[data-rec]');
        var form = rec && rec.querySelector('form');
        var input = form && form.querySelector('input[name="id"]');
        if (!form || !input || rec.classList.contains('is-busy')) return;
        input.value = size.getAttribute('data-rec-size');
        if (!window.customElements || !window.customElements.get('product-form')) {
          /* Dawn's script is missing: fall back to a normal form post to the cart. */
          input.disabled = false;
          form.submit();
          return;
        }
        closeSizes();
        rec.classList.add('is-busy');
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    /* Dawn marks its submit button while the add is running. When that mark is gone, the row is no longer busy. */
    function settle() {
      each(drawer.querySelectorAll('[data-rec].is-busy'), function (rec) {
        if (!rec.querySelector('[type="submit"].loading')) rec.classList.remove('is-busy');
      });
    }

    new MutationObserver(function () {
      fill();
      bar();
      settle();
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    bar();
    fill();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
